import { render } from "./ProductForm.vue?vue&type=template&id=17c840c8&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=17c840c8&lang=scss&scoped=true"

import exportComponent from "/home/forge/logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c840c8"]])

export default __exports__